// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AssetTypeSchema = z.enum(['ENDPOINT','WEBPAGE','DISCOVERED_ASSET'] as const);

export type AssetTypeType = `${z.infer<typeof AssetTypeSchema>}`

export default AssetTypeSchema;
